//React
import { useState, useEffect } from "react";

//Material UI
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CircularProgress from "../CircleProgress";
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';

import "./ForgotPasswordBox.css";
import { LoginApi } from "../../api";

const ForgotPassword = (props) => {
  const [id, setId] = useState(props.userId || "");
  const [step, setStep] = useState(0);
  const [displayVerifyCode, setDisplayVerifyCode] = useState(false);
  const [displayResetPassword, setDisplayResetPassword] = useState(false);
  const [verifyCode, setVerifyCode] = useState("");
  const [passwordShown, setPasswordShown] = useState(false);
  const [confirmPasswordShown, setConfirmPasswordShown] = useState(false);
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [passwordMatch, setPasswordMatch] = useState(false);
  const [passwordInfo, setPasswordInfo] = useState({
    lowercase: false,
    special: false,
    length: false,
  });

  useEffect(() => {
    if (password) {
      const lowercase = /[a-z]/.test(password);
      const special = /[!@#$%^&*]/.test(password);
      const length = password.length >= 8;

      setPasswordInfo({
        lowercase,
        special,
        length,
      });
    } else {
      setPasswordInfo({
        lowercase: false,
        special: false,
        length: false,
      });
    }
  }, [password]);

  useEffect(() => {
    if (passwordConfirm) {
      const passwordMatch = password === passwordConfirm;
      setPasswordMatch(passwordMatch);
    } else {
      setPasswordMatch(false);
    }
  }, [password, passwordConfirm]);

  const backToLogin = () => {
    props.setLoading(false);
    props.handleNavigate('login');
  };

  // step 변경에 따라 UI 업데이트
  useEffect(() => {
    switch (step) {
      case 1:
        setDisplayVerifyCode(true);
        handleVerifyCode(id);
        break;
      case 2:
        // step 2 로직 (인증코드 화면)  
        checkVerifyCode(id, verifyCode);
        break;
      default:
        if(step>=2) {
          setStep(2);
        }
        break;
    }
  }, [step]);

  const handleVerifyCode = async (id) => {
    try {
      const response = await LoginApi.sendVerificationCode({
        userId: id,
      });
      if (response.statusCode === 200) {
        props.setLoading(false);
      } else {
        props.setLoading(false);
        alert("인증코드 전송 실패");
        console.error("인증코드 전송 실패");
      }
    } catch {
      props.setLoading(false);
      alert("인증코드 전송 실패");
      console.error("인증코드 전송 실패");
    }
    finally {
      props.setLoading(false);
    }
  };

  const checkVerifyCode = async (userId, verifyCode) => {
    try {
      const response = await LoginApi.checkVerificationCode({
        userId: id,
        verifyCode: verifyCode,
      });
      if (response.data) {
        props.setLoading(false);
        alert("임시 패스워드가 발급되었습니다. 이메일을 확인하여 다시 로그인해주세요.");
        props.setDisplayResetPassword(true);
        props.handleNavigate('login');
      } else {
        props.setLoading(false);
        alert("인증코드가 일치하지 않습니다.");
      }
    } catch {
      console.error("인증코드 전송 실패");
    }
  };
  
  return (
    <div className="forgot-password-box">
      <div className="forgot-password-form">
        <div className="forgot-password-heading-group">
          <div className="forgot-password-heading">Reset password</div>
          {displayVerifyCode && <div className="forgot-password-subHeading">이메일로 인증코드가 전송 되었습니다. 이메일을 확인해주세요.<br />
            메일이 안왔을 경우, 스팸 메일함을 확인해주세요.</div>}
        </div>
        <div className="forgot-password-form-group">
          <div className="login-label">Email</div>
          <input
            className="login-input"
            type="text"
            placeholder="Email을 입력해주세요."
            value={id}
            disabled={props.loading || displayVerifyCode}
            onChange={(e) => setId(e.target.value)}
          />
        </div>
        {displayVerifyCode && (
          <div className="forgot-password-form-group">
            <div className="login-label">인증코드</div>
            <input
              className="login-input"
              type="text"
              placeholder="인증코드를 입력해주세요."
              value={verifyCode}
              onChange={(e) => setVerifyCode(e.target.value)}
              disabled={props.loading}
            />
          </div>
        )}
      </div>
      <div className="change-password-modal-button-container"
      >
        <button
          className={`back-button`}
          type="button"
          onClick={backToLogin}
        >
          취소
        </button>
        <button
          className={`change-password-modal-next-button ${
            props.loading || !id || (step === 1 && !verifyCode?.trim())
              ? "loading"
              : ""
          }`}
          type="button"
          onClick={() => setStep(prev => prev + 1)}
          disabled={
            props.loading ||
            !id ||
            (step === 1 && !verifyCode?.trim())
          }
        >
          {!props.loading ? (
            "다음"
          ) : (
            <CircularProgress color="white" thickness={4} size={19} />
          )}
        </button>
      </div>
    </div>
  );
};

export default ForgotPassword;
